// React i hooks
import { memo } from "react";

// Tipovi i konstante
import { AnnualTaxSearchResultsProps } from "./types";
import { CALCULATION_ANNUAL_TAX_SEARCH_COLUMNS } from "./consts";
import { initialDataWithPagination } from "services/api/consts";

// UI komponente
import { TableSearch } from "ui/components/Table/TableSearch";


const AnnualTaxSearchResults: React.FC<AnnualTaxSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;


  return (
    <>
      <TableSearch
        columns={CALCULATION_ANNUAL_TAX_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(AnnualTaxSearchResults);
